import * as Icons from "lucide-react";
import { FEATURES } from "../data/mock";

const accentMap = {
  teal: {
    bg: "bg-teal-50",
    text: "text-teal-700",
    border: "border-teal-100",
    badge: "bg-teal-600 text-white",
  },
  emerald: {
    bg: "bg-emerald-50",
    text: "text-emerald-700",
    border: "border-emerald-100",
    badge: "bg-emerald-600 text-white",
  },
  orange: {
    bg: "bg-orange-50",
    text: "text-orange-700",
    border: "border-orange-100",
    badge: "bg-orange-500 text-white",
  },
};

export const Features = () => {
  return (
    <section
      id="features"
      data-testid="features-section"
      className="relative py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <span className="text-xs tracking-[0.22em] uppercase font-semibold text-teal-600">
            One App. Complete Business Management.
          </span>
          <h2
            data-testid="features-headline"
            className="font-heading mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900"
          >
            Everything you need to run your{" "}
            <span className="text-orange-500">hisab</span>, in one place.
          </h2>
          <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
            From invoicing and inventory to WhatsApp reminders and daily cash
            reports — Reptile Hisabbook replaces 7 different notebooks.
          </p>
        </div>

        <div
          data-testid="features-grid"
          className="grid grid-cols-1 md:grid-cols-3 auto-rows-[minmax(180px,_auto)] gap-4 md:gap-5"
        >
          {FEATURES.map((feat, idx) => {
            const Icon = Icons[feat.icon] || Icons.Sparkles;
            const a = accentMap[feat.accent] || accentMap.teal;
            const isBig = feat.span.includes("row-span-2") || feat.span.includes("col-span-2");
            return (
              <div
                key={feat.id}
                data-testid={`feature-card-${feat.id}`}
                className={`group relative ${feat.span} rounded-3xl bg-white border ${a.border} p-6 md:p-7 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 overflow-hidden`}
                style={{ animationDelay: `${idx * 60}ms` }}
              >
                {/* Decorative blob */}
                <div
                  className={`absolute -right-10 -bottom-10 h-40 w-40 rounded-full ${a.bg} opacity-60 group-hover:opacity-100 transition-opacity`}
                />

                <div className="relative z-10 h-full flex flex-col">
                  <div
                    className={`h-12 w-12 rounded-2xl ${a.bg} ${a.text} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}
                  >
                    <Icon className={isBig ? "h-6 w-6" : "h-5 w-5"} />
                  </div>

                  <h3
                    className={`font-heading font-bold text-slate-900 ${
                      isBig ? "text-xl md:text-2xl" : "text-base md:text-lg"
                    } leading-snug`}
                  >
                    {feat.title}
                  </h3>
                  <p className="mt-2 text-sm md:text-[15px] text-slate-600 leading-relaxed">
                    {feat.desc}
                  </p>

                  {isBig && (
                    <div className="mt-auto pt-5 flex items-center gap-2 text-sm font-semibold text-teal-700 group-hover:text-orange-500 transition-colors">
                      Learn more
                      <Icons.ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
